module.exports = __webpack_public_path__ + "static/media/Error.a9e74e6e.png";